import React, { useEffect, useState } from "react";
import logo from "../../Assets/logo.png";
import logoSmall from "../../Assets/icon.png";
import { Link, useLocation } from "react-router-dom";
import { useSidebar } from "../ContextAPI/SidebarContext";
import CryptoJS from "crypto-js";
import { CRYPTO_TOKEN_SECRET_KEY } from "../../config";
import { Stack } from "@mui/material";
import { getPermissionData } from "../../Actions/common";
import {
	MyAddIcon,
	MyArticleOutlinedIcon,
	MyAssessmentIcon,
	MyDashboardCustomizeOutlinedIcon,
	MyPaymentIcon,
	MyPeopleOutlineOutlinedIcon,
	MyRemoveIcon,
	MySupportAgentIcon,
	MyWorkspacePremiumIcon,
} from "../../Assets/svg/MyIcons";

const getUserData = () => {
	const decryptedData = CryptoJS.AES.decrypt(
		localStorage.getItem("userData"),
		CRYPTO_TOKEN_SECRET_KEY
	).toString(CryptoJS.enc.Utf8);
	return JSON.parse(decryptedData);
};

const SideBarComponent = ({ isSandbox }) => {
	const { sideBarOpen } = useSidebar();
	const sidebarClass = sideBarOpen ? "open" : "";

	const userData = localStorage.getItem("userData") ? getUserData() : null;
	const location = useLocation();
	const [activeMenu, setActiveMenu] = useState("");
	const [loading, setLoading] = useState(true);

	const permission = localStorage.getItem(`${userData?.id}_permissionData`)
		? getPermissionData(`${userData?.id}_permissionData`)
		: [];

	useEffect(() => {
		setLoading(true);
		setActiveMenu(location.pathname);
		setLoading(false);
	}, [location.pathname]);

	const menuItems = [
		{
			items: [
				{
					slug: "onboarding-tenant",
					title: "Tenant User",
					icon: (
						<MyPeopleOutlineOutlinedIcon width="25" height="25" />
					),
					to: "/tenant",
					children: [
						{
							slug: "onboarding-tenant",
							title: "Tenant User",
							icon: (
								<MyPeopleOutlineOutlinedIcon
									width="25"
									height="25"
								/>
							),
							to: "/tenant",
						},
					],
				},
				{
					slug: "transaction",
					title: "Transactions",
					icon: <MyPaymentIcon width="25" height="25" />,
					to: "/transactions",
					children: [
						{
							slug: "transaction",
							title: "Transactions",
							icon: <MyPaymentIcon width="25" height="25" />,
							to: "/transactions",
						},
					],
				},
				{
					slug: "reports",
					title: "Reports",
					icon: <MyAssessmentIcon width="25" height="25" />,
					to: "/reports",
					children: [
						{
							slug: "reports",
							title: "Reports",
							icon: <MyAssessmentIcon width="25" height="25" />,
							to: "/reports",
						},
					],
				},
				{
					slug: "plan-management",
					title: "Plan Management",
					icon: <MyWorkspacePremiumIcon width="25" height="25" />,
					to: "/plan-management",
					children: [
						{
							slug: "plan-management",
							title: "Plan Management",
							icon: <MyAssessmentIcon width="25" height="25" />,
							to: "/plan-management",
						},
					],
				},
			],
		},
		{
			items: [
				{
					slug: "users",
					title: "User Management",
					icon: (
						<MyPeopleOutlineOutlinedIcon width="30" height="30" />
					),
					to: "/users",
					children: [
						{
							slug: "users",
							title: "Users",
							icon: (
								<MyPeopleOutlineOutlinedIcon
									width="30"
									height="30"
								/>
							),
							to: "/users",
						},
						{
							slug: "roles",
							title: "Role Management",
							icon: (
								<MyPeopleOutlineOutlinedIcon
									width="30"
									height="30"
								/>
							),
							to: "/role-manager",
						},
					],
				},
				{
					slug: "audit-trail",
					title: "Audit Trail",
					icon: <MyArticleOutlinedIcon width="25" height="25" />,
					to: "/audit-trail",
					children: [
						{
							slug: "audit-trail",
							title: "Audit Trail",
							icon: (
								<MyArticleOutlinedIcon width="25" height="25" />
							),
							to: "/audit-trail",
						},
						{
							slug: "mail-logs",
							title: "Email Logs",
							icon: (
								<MyArticleOutlinedIcon width="25" height="25" />
							),
							to: "/mail-logs",
						},
					],
				},
				{
					slug: "support-ticket",
					title: "Ticketing System",
					icon: <MySupportAgentIcon width="25" height="25" />,
					to: "/support-ticket",
					children: [
						{
							slug: "support-ticket",
							title: "Ticketing System",
							icon: <MySupportAgentIcon width="25" height="25" />,
							to: "/support-ticket",
						},
					],
				},
			],
		},
	];

	const [isOpen, setIsOpen] = useState(false);

	const toggleMenu = () => {
		setIsOpen((prevState) => !prevState);
	};

	const getMenuItems = () => {
		if (loading) {
			return (
				<Stack
					direction="row"
					spacing={2}
					sx={{ flexWrap: "wrap" }}
				></Stack>
			);
		}

		return menuItems.map((group, groupIndex) => {
			const groupElements = [];

			group.items.forEach((menuItem) => {
				const module = permission[0]?.role_permissions?.find(
					(m) => m?.module?.slug === menuItem.slug
				);

				if (!module || !module.canView) return;

				const hasChildren =
					menuItem.children && menuItem.children.length > 0;

				const filteredChildren = menuItem.children?.filter((child) => {
					const childModule = permission[0]?.role_permissions?.find(
						(m) => m?.module?.slug === child.slug
					);
					return childModule && childModule.canView;
				});

				if (hasChildren && filteredChildren.length === 0) return;

				const childSelected =
					hasChildren &&
					filteredChildren.some((elem) => elem.to && activeMenu.startsWith(elem.to));
				groupElements.push(
					<li
						className={hasChildren ? "sb-menu" : ""}
						key={menuItem.slug}
					>
						{hasChildren ? (
							<div
								className={`menu-item ${
									(menuItem.to && activeMenu.startsWith(menuItem.to)) || childSelected
										? "active"
										: ""
								}`}
								style={{
									display: "flex",
									alignItems: "center",
									justifyContent: "space-between",
									cursor: "pointer",
								}}
								onClick={toggleMenu}
							>
								<span
									style={{
										display: "flex",
										alignItems: "center",
									}}
								>
									<span className="menu-icon">
										{menuItem.icon}
									</span>
									<span
										className="menu-title"
										style={{ marginLeft: "8px" }}
									>
										{menuItem.title}
									</span>
								</span>
								<span className="ico-sb">
									{isOpen ? <MyRemoveIcon /> : <MyAddIcon />}
								</span>
							</div>
						) : (
							<Link
								to={menuItem.to}
								className={`menu-item ${
									(menuItem.to && activeMenu.startsWith(menuItem.to)) ? "active" : ""
								}`}
								style={{
									display: "flex",
									alignItems: "center",
								}}
							>
								<span className="menu-icon">
									{menuItem.icon}
								</span>
								<span
									className="menu-title"
									style={{ marginLeft: "8px" }}
								>
									{menuItem.title}
								</span>
							</Link>
						)}

						{hasChildren && (
							<ul
								className={`list-unstyled list-inline m-0 z-index-1 ${
									isOpen ? "open" : "closed"
								}`}
							>
								{filteredChildren.map((child) => (
									<li key={child.slug}>
										<Link
											to={child.to}
											className={`menu-item ${
												(child.to && (activeMenu === child.to || activeMenu.startsWith(child.to)))
													? "active"
													: ""
											}`}
											style={{
												display: "flex",
												alignItems: "center",
												paddingLeft: "25px",
												fontSize: "14px",
											}}
										>
											<span className="menu-title">
												{child.title}
											</span>
										</Link>
									</li>
								))}
							</ul>
						)}
					</li>
				);
			});

			return (
				<React.Fragment key={`group-${groupIndex}`}>
					{groupElements}
				</React.Fragment>
			);
		});
	};

	return (
		<div
			id="kt_aside"
			className={`${
				sidebarClass
					? "aside drawer drawer-start drawer-on"
					: !sidebarClass
					? "aside drawer drawer-start"
					: "aside "
			} ${isSandbox ? "sandbox" : ""}`}
			data-kt-drawer="true"
			data-kt-drawer-name="aside"
			data-kt-drawer-activate="{default: true, lg: false}"
			data-kt-drawer-overlay="true"
			data-kt-drawer-width="{default:'80px', '300px': '100px'}"
			data-kt-drawer-direction="start"
			data-kt-drawer-toggle="#kt_aside_mobile_toggle"
		>
			<div className="aside-menu flex-column-fluid" id="kt_aside_menu">
				<div className="aside-logo d-none">
					<Link to="/dashboard" className="w-100 d-flex text-center">
						<img
							alt="Logo"
							src={`${logo}`}
							style={{ width: "250px" }}
							className="position-relative px-3 m-auto py-3"
						/>
					</Link>
				</div>
				<div className="aside-logo-small d-none">
					<Link to="/dashboard" className="w-100 d-flex text-center">
						<img
							alt="Logo"
							src={`${logoSmall}`}
							style={{ width: "65px" }}
							className="position-relative px-3 m-auto py-4"
						/>
					</Link>
				</div>
				<div
					className="menu menu-column menu-xl-row menu-title-gray-700 h-100"
					id="#kt_aside_menu"
					data-kt-menu="true"
				>
					<ul className="list-unstyled w-100 mt-5 h-100 d-flex flex-column pb-5">
						<li className={"sb-menu"} key="dashboard">
							{
								<div
									className={`menu-item ${
										activeMenu.startsWith("/dashboard")
											? "active"
											: ""
									}`}
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "space-between",
										cursor: "pointer",
									}}
									onClick={toggleMenu}
								>
									<span
										style={{
											display: "flex",
											alignItems: "center",
										}}
									>
										<span className="menu-icon">
											<MyDashboardCustomizeOutlinedIcon />
										</span>
										<span
											className="menu-title"
											style={{ marginLeft: "8px" }}
										>
											Dashboard
										</span>
									</span>
									<span
										className="ico-sb"
									>
										{isOpen ? (
											<MyRemoveIcon />
										) : (
											<MyAddIcon />
										)}
									</span>
								</div>
							}

							<ul
								className={`list-unstyled list-inline m-0 z-index-1 ${
									isOpen ? "open" : "closed"
								}`}
							>
								<li key="dashboard">
									<Link
										to="/dashboard"
										className={`menu-item ${
											activeMenu.startsWith("/dashboard")
												? "active"
												: ""
										}`}
										style={{
											display: "flex",
											alignItems: "center",
											paddingLeft: "25px",
											fontSize: "14px",
										}}
									>
										<span className="menu-title">
											Dashboard
										</span>
									</Link>
								</li>
							</ul>
						</li>
						{/* Other Menu Items */}
						{getMenuItems()}
					</ul>
				</div>
			</div>
		</div>
	);
};

export default SideBarComponent;
